import styled, { css } from 'styled-components';
import { Card } from 'antd';

export const CardContainer = styled(Card)`
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        transform: scale(1.01);
        background: ${({ theme }) => theme.colors.background1};
      }
    `}

  .ant-card-body {
    padding: 16px;

    .ant-statistic {
      display: flex;
      flex-direction: column;
    }

    .ant-statistic-title {
      margin-bottom: 8px;
      font-weight: 500;
      font-size: ${({ theme }) => theme.fontSizes.small};
      color: ${({ theme }) => theme.colors.text1};
    }

    .ant-statistic-content {
      display: inline-flex;
      align-items: center;
    }

    .ant-statistic-content-value {
      color: ${({ theme }) => theme.colors.primary};
      font-size: ${({ theme }) => theme.fontSizes.large};
      line-height: ${({ theme }) => theme.fontSizes.large};
    }

    .ant-statistic-content-suffix {
      color: ${({ theme }) => theme.colors.text1};
      font-size: ${({ theme }) => theme.fontSizes.small};
      line-height: ${({ theme }) => theme.fontSizes.small};
    }
  }
`;

export const CardContent = styled.div`
  display: flex;

  .stat-card-content-icon {
    width: 32px;
    height: 100%;
    align-self: center;

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
